import type { Template } from "@/types";

export const PO_07_H6_V1: Template[] = [
    {
        id: "po-07-h6v1-01",
        name: "PO 01 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 49, y: 255, width: 304, height: 199, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 462, width: 304, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 361, y: 255, width: 278, height: 405, rotation: 0, imageRotation: 0 },
            { id: "4", x: 736, y: 255, width: 291, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 736, y: 462, width: 291, height: 199, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 255, width: 291, height: 199, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1035, y: 462, width: 291, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-02",
        name: "PO 02 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 53, y: 172, width: 581, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 555, width: 287, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 555, width: 286, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 737, y: 172, width: 241, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 737, y: 365, width: 241, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 737, y: 558, width: 241, height: 185, rotation: 0, imageRotation: 0 },
            { id: "7", x: 986, y: 172, width: 334, height: 571, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h6v1-03",
        name: "PO 03 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 56, y: 202, width: 581, height: 380, rotation: 0, imageRotation: 0 },
            { id: "3", x: 56, y: 590, width: 189, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 253, y: 590, width: 188, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 449, y: 590, width: 188, height: 124, rotation: 0, imageRotation: 0 },
            { id: "2", x: 736, y: 140, width: 581, height: 368, rotation: 0, imageRotation: 0 },
            { id: "7", x: 736, y: 516, width: 392, height: 260, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1136, y: 516, width: 181, height: 260, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-04",
        name: "PO 04 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 50, y: 133, width: 290, height: 212, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 133, width: 290, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 50, y: 353, width: 290, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 348, y: 353, width: 290, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 50, y: 573, width: 290, height: 211, rotation: 0, imageRotation: 0 },
            { id: "6", x: 348, y: 573, width: 290, height: 211, rotation: 0, imageRotation: 0 },
            { id: "7", x: 808, y: 133, width: 445, height: 650, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h6v1-05",
        name: "PO 05 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 65, y: 236, width: 305, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 462, width: 305, height: 218, rotation: 0, imageRotation: 0 },
            { id: "3", x: 378, y: 236, width: 305, height: 218, rotation: 0, imageRotation: 0 },
            { id: "4", x: 378, y: 462, width: 305, height: 218, rotation: 0, imageRotation: 0 },
            { id: "7", x: 691, y: 236, width: 305, height: 444, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1004, y: 236, width: 305, height: 218, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1004, y: 462, width: 305, height: 218, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-06",
        name: "PO 06 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 105, y: 120, width: 471, height: 334, rotation: 0, imageRotation: 0 },
            { id: "2", x: 105, y: 462, width: 471, height: 334, rotation: 0, imageRotation: 0 },
            { id: "3", x: 584, y: 120, width: 435, height: 676, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1027, y: 120, width: 242, height: 163, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1027, y: 291, width: 242, height: 163, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1027, y: 462, width: 242, height: 163, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1027, y: 633, width: 242, height: 163, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-07",
        name: "PO 07 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 51, y: 140, width: 297, height: 207, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 355, width: 297, height: 207, rotation: 0, imageRotation: 0 },
            { id: "3", x: 51, y: 570, width: 297, height: 207, rotation: 0, imageRotation: 0 },
            { id: "4", x: 356, y: 140, width: 389, height: 637, rotation: 0, imageRotation: 0 },
            { id: "5", x: 753, y: 140, width: 570, height: 416, rotation: 0, imageRotation: 0 },
            { id: "6", x: 753, y: 564, width: 281, height: 213, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1042, y: 564, width: 281, height: 213, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h6v1-08",
        name: "PO 08 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 75, y: 178, width: 371, height: 560, rotation: 0, imageRotation: 0 },
            { id: "2", x: 454, y: 178, width: 277, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 454, y: 368, width: 277, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 454, y: 557, width: 277, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 739, y: 557, width: 277, height: 181, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1024, y: 557, width: 276, height: 181, rotation: 0, imageRotation: 0 },
            { id: "7", x: 739, y: 178, width: 561, height: 371, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-09",
        name: "PO 09 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 75, y: 178, width: 371, height: 560, rotation: 0, imageRotation: 0 },
            { id: "2", x: 454, y: 178, width: 562, height: 371, rotation: 0, imageRotation: 0 },
            { id: "3", x: 454, y: 557, width: 277, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 739, y: 557, width: 277, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1024, y: 178, width: 276, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1024, y: 368, width: 276, height: 181, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1024, y: 557, width: 276, height: 181, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h6v1-10",
        name: "PO 10 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 75, y: 178, width: 562, height: 371, rotation: 0, imageRotation: 0 },
            { id: "2", x: 75, y: 557, width: 277, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 360, y: 557, width: 277, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 645, y: 178, width: 371, height: 560, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1024, y: 178, width: 276, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1024, y: 368, width: 276, height: 181, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1024, y: 557, width: 276, height: 181, rotation: 0, imageRotation: 0 },
        ],
    },

];
